import CommonDrawer from "../../../App/commonDrawer"
import CommonModal from "../../../App/commonModal"
import React, { useEffect, useState } from "react";
import { Context,Hooks,Util,Request } from "@xt/xtbase";
import {get_profileInvitees, delete_profileInvitee} from "@/api/referral";
import { Table, Space, Modal } from "antd";
import deletePng from "assets/images/home/deletePng.png";
import Nodata from "assets/images/home/nodata.png";
import { ExclamationCircleFilled } from '@ant-design/icons';
import { useIntl, FormattedMessage } from "react-intl";
import { toUtc } from "utils/date";

let scrollTop = 0;
const {useTranslation, useDocumentWidth} = Hooks;
const {getOrigin, getUrl} = Util;
const { confirm } = Modal;

function InviteesDrawer (props) {
  const { isShowModal, onClose, getInviteCodeList, inviteCode } = props;
  const t = useTranslation();
  const [invitees, setInvitees] = useState([])
  const [isShowDeleteModal, setIsShowDeleteModal] = useState(false)
  const [userId, setUserId] = useState(null)

  const showConfirm = (record) => {
    // confirm({
    //   title: 'Do you Want to delete these items?',
    //   icon: <ExclamationCircleFilled />,
    //   onOk() {
    //     deleteInvitee(record.userId)
    //   },
    //   onCancel() {
    //     console.log('Cancel');
    //   },
    // });
    setUserId(record.userId)
    setIsShowDeleteModal(true)
  };

  const deleteInvitee = (userId) =>{
    delete_profileInvitee({
      successPop: true,
      params: {
        inviteeUserId: userId
      }
    }).then(()=>{
      getProfileInvitees()
      getInviteCodeList()
    })
  }

  useEffect(()=>{
    const getData = async() => {
      getProfileInvitees()
    }
    getData()
  },[])

  useEffect(()=>{
    if (isShowModal) {
      // 使body脱离文档流
      scrollTop = document.documentElement.scrollTop;
      document.body.classList.add('at-frozen');
      // 把脱离文档流的body拉上去！否则页面会回到顶部！
      document.body.style.top = `${-scrollTop}px`;
    } else {
      document.body.style.top = null;
      document.body.classList.remove('at-frozen');
      document.documentElement.scrollTop = scrollTop;
    }
  },[isShowModal])


  const getProfileInvitees = async() => {
    const invitees = await get_profileInvitees({
      params: {
        inviteCode,
        limit: 99999,
      }
    })
    setInvitees(invitees.items || [])
  }

  const onDeleteClose = () =>{
    setIsShowDeleteModal(false)
  }

  const onSave = () => {
    deleteInvitee()
  };

  return (
    <>
      <CommonDrawer title={t("home.friendList")} isShowModal={isShowModal} onClose={onClose} height={526}>
        <div className="InviteesDrawer">
          <div className="header">
            <div>{t("home.friendId")}</div>
            <div>{t("console.board.registerTime")}</div>
          </div>
          {invitees?.length != 0 && invitees?.map((_)=>(<div className="Invitees">
              <div>{_.userId}</div>
              <div>{toUtc(_.regTime)}</div>
              {/* <img src={deletePng} onClick={()=>showConfirm(_)} /> */}
            </div>
          ))}
          {invitees.length == 0 && <div className="nodata">
            <img src={Nodata} className="nodataImg" />
            <div className="nodataTitle">{ t("home.NoRecent") }</div>
          </div>}
        </div>
      </CommonDrawer>
      <CommonModal width={280} title={t("console.link.deleteInvited")} isShowModal={isShowDeleteModal} onClose={onDeleteClose} closable={false}>
        <div className="deleteInviteModal">
          <div className="sureDelete">
            <FormattedMessage
              id="home.sureDelete"
              values={{ userId }}
            />
          </div>
          <div className="foot1">
            <div className="cancel" onClick={onDeleteClose}>{t("home.cancel")}</div>
            <div className="save" onClick={onSave}>{t("home.save")}</div>
          </div>
        </div>
      </CommonModal>
    </>
  )

}

export default InviteesDrawer
